export default __webpack_public_path__ + "static/media/Strifescar Girdle.7fec565e.jpg";